import {format} from 'utils'
import request from 'crm/utils/request'
import api from './api'

export async function getChannels() {
    return request(api.getChannels.url)
}

export async function updateChannel(payload) {
    return request(format(api.updateChannel.url, {id: payload.id}), {
        method: api.updateChannel.type,
        body: payload.body,
    })
}

export async function addChannel(payload) {
    return request(api.addChannel.url, {
        method: api.addChannel.type,
        body: payload.body,
    })
}

export async function deleteChannel(payload) {
    return request(format(api.deleteChannel.url, {id: payload.id}), {
        method: api.deleteChannel.type,
    })
}

export async function getDrainageCont(payload) {
    return request(format(api.getDrainageCont.url, {id: payload.id}))
}

export async function setDrainageCont(payload) {
    return request(format(api.setDrainageCont.url, {id: payload.id}), {
        method: api.setDrainageCont.type,
        body: payload.body,
    })
}
